import React from 'react'
import { useTranslation } from 'next-i18next'
import styled from '@emotion/styled'
import Row from 'modules/ui/atoms/Layout/Row'
import Column from 'modules/ui/atoms/Layout/Column'

import InputField from 'modules/ui/molecules/FormComponents/InputField'
import { FieldErrors } from 'react-hook-form'
import TextAreaField from 'modules/ui/molecules/FormComponents/TextAreaField'
import { DEFAULT_THEME_COLORS } from '../../../../tokens'

type OrderDedicationRecipientFieldsPropType = {
  errors: FieldErrors
  isEmailToggleChecked: boolean
}

const StyledDiv = styled.div`
  padding: 16px;
  background-color: ${DEFAULT_THEME_COLORS['--theme-color__background-accent']};
  border-radius: 8px;
`

const OrderDedicationRecipientFields = (props: OrderDedicationRecipientFieldsPropType) => {
  const { t } = useTranslation()
  const { errors, isEmailToggleChecked } = props

  const RecipientEmailField = (
    <InputField
      required
      label={t('orderDedicationRecipientFields.recipientEmailAddress.label', 'Email')}
      id="recipientEmailAddress"
      dataId="dedication-recipient-email-input"
      error={errors.recipientEmailAddress as { message: string }}
    />
  )

  const RecipientFirstNameField = (
    <InputField
      id="recipientFirstName"
      label={t('orderDedicationRecipientFields.recipientFirstName.label', 'First name')}
      dataId="dedication-recipient-first-name-input"
      error={errors.recipientFirstName as { message: string }}
      required
    />
  )

  const RecipientLastNameField = (
    <InputField
      id="recipientLastName"
      label={t('orderDedicationRecipientFields.recipientLastName.label', 'Last name')}
      dataId="dedication-recipient-last-name-input"
      error={errors.recipientLastName as { message: string }}
      required
    />
  )

  const RecipientMessageField = (
    <TextAreaField
      id="ecardMessage"
      label={t('orderDedicationRecipientFields.ecardMessage.label', 'Message')}
      required={false}
      dataId="dedication-recipient-message-textarea"
    />
  )

  return (
    <StyledDiv>
      <h4>{t('orderDedicationRecipientFields.heading', 'Who should receive the dedication?')}</h4>
      {isEmailToggleChecked && (
        <Row>
          <Column> {RecipientEmailField}</Column>
        </Row>
      )}

      <Row>
        <Column style={{ marginRight: '16px' }}>{RecipientFirstNameField}</Column>
        <Column>{RecipientLastNameField}</Column>
      </Row>

      <Row>
        <Column> {RecipientMessageField}</Column>
      </Row>
    </StyledDiv>
  )
}

export default OrderDedicationRecipientFields
